import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';
import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import Datos from './Datos';
import Hacienda from './Hacienda';
import ConsecutivosContenedor from './ConsecutivosContenedor';
import Usuarios from './Usuarios';
import loading from '../New Template/images/loading.gif';
import '../Companias/BotonesPestanas.css';
import { useAuth } from '../contextos/AuthProvider'
import { EncApi, EncabezadoPost } from '../Comunes/Listas';

const DetalleCia = (props) => {

    const navigate = useNavigate();
    const { Token } = useAuth();

    const Salir = () => {
        navigate("/Companias/GeneralCia");
    }

    const handleOnSubmit = (e) => {
        console.log("in submit");
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file instanceof Blob) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
                setGestor({ ...Gestor, "LlaveBase64": base64String, "RutaLlave": file.name });
                console.log(base64String);
            };
            reader.readAsDataURL(file);
        } else {
            console.error("The selected file is not a valid Blob.");
        }
    }

    const AccionProvincia = (codigo) => {
        axios.get(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/CantonesDeProvincia?Id=${codigo}`, EncApi(Token))
            .then(res => {
                const { data } = res;
                console.log(data);
                setLosCantones(data.CantonesVecinos);
                setLosDistritos(data.DistritosVecinos);
            });

        setGestor({ ...Gestor, "Provincia": codigo, "Canton": "1", "Distrito": "1" });
    }

    const [Gestor, setGestor] = React.useState({
        IdCia: 0,
        BDCompania: '',
        NombreCliente: '',
        Cedula: '',
        Codigo: '',
        NotaNC: 'D',
        SNcontado: '0',
        Ambiente: 'T',
        TipoCedula: '02',
        NotaExtraDetalle: 'CRC'
    });

    const CambiaDatosGestor = (e) => {
        const { className, name, value, type } = e.target;

        if (className === 'ck') {
            e.target.checked = false;
        }

        switch (name) {
            case 'Provincia':
                AccionProvincia(value);
                break;

            case 'Canton':
                axios.get(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/DistritosDeCanton?IdProvincia=${Gestor.Provincia}&idCanton=${value}`, EncApi(Token))
                    .then(res => {
                        const { data } = res;
                        setLosDistritos(data);
                        setGestor({
                            ...Gestor,
                            "Canton": (type === 'number') ? parseInt(value) : value,
                            "Distrito": "1"
                        });
                    });
                break;

            default:
                setGestor({
                    ...Gestor,
                    [name]: (type === 'number') ? parseInt(value) : value
                });
        }
    }

    function ValidarDatos() {
        let Mensaje = '';

        if (!InfoLicencia[0]) {
            Mensaje = 'Falta información de Datos Compañia';
        }

        if (LosUsuarios.length === 0) {
            Mensaje = 'Falta información de Usuarios';
        }

        if (LosConsecutivos.length === 0) {
            Mensaje = 'Falta información de Consecutivos';
        }

        if (LasActividades.length === 0) {
            Mensaje = 'Falta información de Actividades';
        }

        if (Gestor.SNcontado || Gestor.SNcontado === '') {
            Mensaje = 'Falta información de Descuento';
        }

        if (Gestor.NotaND || Gestor.NotaND === '') {
            Mensaje = 'Falta información de Nota de Monto Mensual';
        }

        return Mensaje;
    }

    const Guardar = () => {
        let Mensaje = ValidarDatos();

        if (Mensaje !== '') {
            Swal.fire({
                title: '¿Seguro en guardar los datos de Compañia?',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Si, de acuerdo',
                denyButtonText: `No, Cancelar`,
            }).then(async (result) => {

                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Enviando...",
                        text: "Favor esperar mientras se guarda la información",
                        position: 'top-center',
                        imageUrl: loading,
                        backdrop: true,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    let compania = {
                        Gestor: Gestor,
                        LlaveBase64: Gestor.LlaveBase64,
                        InfoLicencia: InfoLicencia[0],
                        MisUsuarios: LosUsuarios,
                        MisConsecutivos: LosConsecutivos,
                        MisActividades: LasActividades
                    }

                    console.log(JSON.stringify(compania));

                    await fetch(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/GuardaCompania`, EncabezadoPost(Token, compania))
                        .then(async res => {
                            if (res.status === 200) {
                                const data = await res.json();

                                if (data[0].Codigo > 0) {
                                    Swal.fire({
                                        position: 'top-center',
                                        icon: 'success',
                                        title: 'Compañia Guardada Exitosamente',
                                        showConfirmButton: false,
                                        timer: 1200
                                    });

                                    navigate("/Companias/GeneralCia");
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Error al guardar',
                                        text: data[0].Mensaje,
                                    });
                                }
                            } else {
                                console.error("Error: ", res.status);
                            }
                        })
                        .catch(error => {
                            console.error("Error: ", error);
                        });
                }
            })
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: Mensaje,
            });
        }
    }

    const [ModoActual, setModoActual] = React.useState('D');

    const [LosConsecutivos, setConsecutivos] = React.useState([]);

    const ActualizarConsecutivo = index => e => {
        const { name, value, type } = e.target;
        console.log(index);

        let Lista = LosConsecutivos.map((item, i) =>
            i === index
                ? { ...item, [name]: (type === 'number') ? parseInt(value) : value }
                : item
        );

        setConsecutivos(Lista);
    };

    const EliminarConsecutivo = (index) => {
        const newConsecutivos = [...LosConsecutivos];
        newConsecutivos.splice(index, 1);
        setConsecutivos(newConsecutivos);
    };

    const AgregarConsecutivo = (nuevoConsecutivo) => {
        setConsecutivos([...LosConsecutivos, nuevoConsecutivo]);
    };

    const AutoAsignar = () => {
        setConsecutivos([
            { Tipo: "FAC", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "TIQ", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "EXP", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "NC", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "ND", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "FEC", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "MR", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "COT", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "REP", Sucursal: "001", Terminal: 1, Siguiente: 1 },
            { Tipo: "PED", Sucursal: "001", Terminal: 1, Siguiente: 1 }
        ]);
    };

    const [LosUsuarios, setUsuarios] = React.useState([]);

    const AgregarUsuario = (nuevoUsuario) => {
        setUsuarios([...LosUsuarios, nuevoUsuario]);
    };

    const ActualizarUsuario = index => e => {
        const { name, value, type } = e.target;

        let Lista = LosUsuarios.map((item, i) =>
            i === index
                ? { ...item, [name]: (type === 'number') ? parseInt(value) : value }
                : item
        );

        setUsuarios(Lista);
    };

    const ResetearClave = (index) => {
        axios.get(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/CambiarClave?CodigoUsuario=${LosUsuarios[index].CODIGO}&Clave=${LosUsuarios[index].CLAVE}`, EncApi(Token))
            .then(res => {
                if (res.status === 200) {
                    const { data } = res;
                    console.log(data);

                    if (data.Codigo === 0) {
                        Swal.fire({
                            position: 'top-center',
                            icon: 'success',
                            title: 'Clave reseteada Exitosamente',
                            showConfirmButton: false,
                            timer: 1200
                        });
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al guardar',
                            text: data.Mensaje,
                        });
                    }
                } else {
                    console.error("Error: ", res.status);
                }
            })
            .catch(error => {
                console.error("Error: ", error);
            });
    }

    const EliminarUsuario = (index) => {
        const newUsuarios = [...LosUsuarios];
        newUsuarios.splice(index, 1);
        setUsuarios(newUsuarios);
    };

    // Actividades
    const [LasActividades, setActividades] = React.useState([]);

    const EliminarActividad = (index) => {
        const newActividades = [...LasActividades];
        newActividades.splice(index, 1);
        setActividades(newActividades);
    };

    const AgregarActividad = (nuevaActividad) => {
        console.log(nuevaActividad);
        setActividades([...LasActividades, nuevaActividad]);
    };

    const ObtenerActividadesdeDesdeHacienda = async () => {

    try {
        console.log(`Obteniendo actividades para cédula: ${Gestor.Cedula}`);
        const response = await axios.get(
            `https://api.hacienda.go.cr/fe/ae?identificacion=${Gestor.Cedula}`
        );

        const actividades = response.data.actividades || [];

        const arregloActividades = actividades.map((item) => ({
            CodigoActividad: item.codigo,
            NombreActividad:
                item.descripcion.length > 100
                    ? item.descripcion.substring(0, 100)
                    : item.descripcion
        }));

        setActividades(arregloActividades);

    } catch (error) {

        console.error(error);

        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No fue posible obtener las actividades desde Hacienda'
        });

        setActividades([]);
    }
}


    // Datos Compañia
    const [LosCantones, setLosCantones] = React.useState([]);
    const [LosDistritos, setLosDistritos] = React.useState([]);

    const [InfoLicencia, setInfoLicencia] = React.useState([]);

    const CambiaInfoLicencia = (e) => {
        const { name, value, type } = e.target;

        setInfoLicencia(prevInfoLicencia => {
            const updatedInfoLicencia = [...prevInfoLicencia];
            updatedInfoLicencia[0] = {
                ...updatedInfoLicencia[0],
                [name]: (type === 'number') ? parseInt(value) : value
            };
            return updatedInfoLicencia;
        });
    }

    const SubirLogo = (e) => {
        console.log('Subiendo logo...');
        const file = e.target.files[0];

        if (file instanceof Blob) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");

                setInfoLicencia(prevInfoLicencia => {
                    const updatedInfoLicencia = [...prevInfoLicencia];
                    updatedInfoLicencia[0] = {
                        ...updatedInfoLicencia[0],
                        "LOGO": base64String
                    };
                    return updatedInfoLicencia;
                });
            };

            reader.readAsDataURL(file);
        } else {
            console.error("The selected file is not a valid Blob.");
        }
    }

    React.useEffect(() => {

        if (props.EntidadActual > 0) {
            axios.get(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/ObtenerCompaniaPorId?Id=${props.EntidadActual}`, EncApi(Token))
                .then(res => {
                    const { data } = res;

                    setLosCantones(data.CantonesVecinos);
                    setLosDistritos(data.DistritosVecinos);
                    setGestor(data.Compania);
                    setConsecutivos(data.Consecutivos);
                    setUsuarios(data.Usuarios);
                    setActividades(data.Actividades);
                    setInfoLicencia(data.InfoLicencia);
                });
        }
        else {
            console.log("nueva compañia");
            AccionProvincia('1');
            setConsecutivos([]);
            setUsuarios([]);
            setActividades([]);

            setInfoLicencia(prevInfoLicencia => {
                const updatedInfoLicencia = [...prevInfoLicencia];
                updatedInfoLicencia[0] = {
                    ...updatedInfoLicencia[0],
                    "LOGO": null,
                    "ESTADO": '1',
                    "FECHA": new Date().toISOString().split('T')[0],
                    "CLIENTE": '0'
                };
                return updatedInfoLicencia;
            });
        }

        // eslint-disable-next-line
    }, []);

    const tabs = [
        { id: 'D', texto: 'Datos' },
        { id: 'H', texto: 'Hacienda' },
        { id: 'C', texto: 'Consecutivos' },
        { id: 'U', texto: 'Usuarios' }
    ];

    if (Gestor && InfoLicencia[0]) {
        return <div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                <div className='formadoShadow'>

                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}>
                            Datos Compañía {Gestor.IdCia + ' ' + Gestor.RazonSocial + ' ' + Gestor.NombreComercial}
                        </p>

                        <button
                            className="botonCerrar"
                            style={{ backgroundColor: '#f3f3f3', width: '50px' }}
                            id="SalirHome"
                            onClick={Salir}
                            name="SalirHome"
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    </div>

                    <div style={topActionBarStyle}>
                        <button
                            type="button"
                            onClick={Guardar}
                            style={guardarButtonStyle}
                        >
                            Guardar
                        </button>
                    </div>

                    <div style={folderTabsStyle}>
                        {tabs.map((t) => (
                            <button
                                key={t.id}
                                type="button"
                                onClick={() => setModoActual(t.id)}
                                style={ModoActual === t.id ? folderTabActiveStyle : folderTabStyle}
                            >
                                {t.texto}
                            </button>
                        ))}
                    </div>

                    <div style={folderBodyStyle}>

                        {ModoActual === 'D' ? <Datos
                            Gestor={Gestor}
                            CambiaDatosGestor={CambiaDatosGestor}
                            LosCantones={LosCantones}
                            InfoLicencia={InfoLicencia}
                            SubirLogo={SubirLogo}
                            CambiaInfoLicencia={CambiaInfoLicencia}
                            LosDistritos={LosDistritos}
                        /> : null}

                        {ModoActual === 'H' ? <Hacienda
                            Gestor={Gestor}
                            handleFileUpload={handleFileUpload}
                            CambiaDatosGestor={CambiaDatosGestor}
                            LasActividades={LasActividades}
                            ObtenerActividadesdeDesdeHacienda={ObtenerActividadesdeDesdeHacienda}
                            EliminarActividad={EliminarActividad}
                            AgregarActividad={AgregarActividad}
                        /> : null}

                        {ModoActual === 'C' ? <ConsecutivosContenedor
                            LosConsecutivos={LosConsecutivos}
                            EliminarConsecutivo={EliminarConsecutivo}
                            AutoAsignar={AutoAsignar}
                            ActualizarConsecutivo={ActualizarConsecutivo}
                            AgregarConsecutivo={AgregarConsecutivo}
                            IdCia={Gestor.IdCia}
                        /> : null}

                        {ModoActual === 'U' ? <Usuarios
                            Losusuarios={LosUsuarios}
                            AgregarUsuario={AgregarUsuario}
                            ActualizarUsuario={ActualizarUsuario}
                            ResetearClave={ResetearClave}
                            EliminarUsuario={EliminarUsuario}
                        /> : null}

                    </div>

                </div>
            </div>
        </div>
    }
    else {
        return <h2>Cargando...</h2>
    }
};

const topActionBarStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '12px 10px 6px 10px',
    background: '#f8f9fa',
    borderBottom: '1px solid #e5e7eb'
};

const guardarButtonStyle = {
    background: '#198754',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontWeight: '700',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,.15)'
};

const folderTabsStyle = {
    display: 'flex',
    gap: '4px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '12px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    background: '#f8f9fa'
};

const folderTabStyle = {
    padding: '11px 22px',
    border: '1px solid #cfd7df',
    borderBottom: 'none',
    borderRadius: '14px 14px 0 0',
    background: '#e9ecef',
    color: '#333',
    fontWeight: '700',
    cursor: 'pointer',
    minWidth: '135px'
};

const folderTabActiveStyle = {
    ...folderTabStyle,
    background: '#fff',
    color: '#198754',
    transform: 'translateY(1px)',
    boxShadow: '0 -3px 10px rgba(0,0,0,.08)'
};

const folderBodyStyle = {
    background: '#fff',
    border: '1px solid #cfd7df',
    borderRadius: '0 14px 14px 14px',
    padding: '16px 10px 10px 10px',
    margin: '0 10px 10px 10px',
    boxShadow: '0 6px 18px rgba(0,0,0,.08)'
};

export default DetalleCia;